import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';
import { CoreEnums } from '@/utils/domain/constants';
import Filters, { registerModuleFilters } from '@/utils/input/filters';

const ProviderFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'provider',
  label: 'agents.form.provider',
  enumNamespace: getEnumNamespace(CoreEnums.AIProvider, 'AI'),
  enumSource: CoreEnums.AIProvider,
  options: createEnumOptions(CoreEnums.AIProvider, 'agents.ai.provider'),
};

const ModelFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'modelId',
  label: 'agents.form.model',
  apiRoute: 'ai/model/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const MemoryFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'memoryId',
  label: 'agents.form.memory',
  apiRoute: 'ai/memory/paged',
  params: {
    select: 'id,name',
    filter: 'isActive eq true',
    orderBy: 'name asc',
  },
};

const AgentPlatformFilter = {
  ...Filters.BaseFilters.EnumFilter,
  name: 'agentPlatform',
  label: 'agents.form.platform',
  enumNamespace: getEnumNamespace(CoreEnums.RpaAgentPlatform, 'RPA'),
  enumSource: CoreEnums.RpaAgentPlatform,
  options: createEnumOptions(CoreEnums.RpaAgentPlatform, 'agents.rpa.platform'),
};

const CreatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.createdDate',
  defaultValue: CoreEnums.FilterDateRange.Disabled,
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  label: 'global.text.updatedDate',
  name: 'updatedDateRange',
  defaultValue: CoreEnums.FilterDateRange.Disabled,
};

const OwnerFilter = {
  ...Filters.BaseFilters.RemoteFilter,
  name: 'ownerUserId',
  label: 'agents.text.ownerUser',
  apiRoute: 'user/paged',
  params: { select: 'id,fullName', orderBy: 'fullName asc' },
};

const IsPublicFilter = {
  ...Filters.BaseFilters.BooleanFilter,
  name: 'isPublic',
  label: 'global.text.isPublic',
};

export const aiFiltersConfig = [
  ProviderFilter,
  ModelFilter,
  MemoryFilter,
  Filters.IsActiveFilter,
  IsPublicFilter,
  OwnerFilter,
  CreatedDateFilter,
  UpdatedDateFilter,
];

export const rpaFiltersConfig = [AgentPlatformFilter, Filters.IsActiveFilter, CreatedDateFilter];

export const filtersConfig = aiFiltersConfig;

registerModuleFilters('agents', [
  ProviderFilter,
  ModelFilter,
  MemoryFilter,
  AgentPlatformFilter,
  IsPublicFilter,
  OwnerFilter,
]);
